import { decode } from "../../config";
import { apiFetch } from "../../utils/api";

const API_BASE_URL = decode(window._env_?.API_BASE_URL);

export const allCategoryAction = () => async (dispatch) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Category/unauth_AllCategories`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      console.error(
        "Failed to fetch categories:",
        response.status,
        response.statusText
      );
      dispatch({ type: "GET_unauth_CATEGORY", payload: [] });
      return;
    }

    const data = await response.json();
    dispatch({ type: "GET_unauth_CATEGORY", payload: data });

    return data;
  } catch (err) {
    console.error("Error loading categories details:", err);
  }
};

export const allAvailableCategoryAction = () => async (dispatch) => {
  try {
    const res = await apiFetch(`${API_BASE_URL}/Category/AllCategories`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    if (res.status === 204) {
      dispatch({ type: "GET_LISTS_CATEGORIES", payload: null });
      return null;
    }
    const data = await res.json();
    dispatch({ type: "GET_LISTS_CATEGORIES", payload: data });
  } catch (err) {
    console.error("Failed to fetch category:", err);
  }
};

export const addNewCategory = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/Category/AddCategory`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "ADD_CATEGORY", payload: data });
    return obj;
  } catch (err) {
    console.error("Error adding category details:", err);
  }
};

export const updateCategory = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/Category/UpdateCategory`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "UPDATE_CATEGORY", payload: data });
  } catch (err) {
    console.error("Error updating category:", err);
  }
};

export const deleteCategory = (id) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/Category/DeleteCategory`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(id) }),
    });
    if (!response.ok) {
      throw new Error("Failed to delete category details");
    }

    const data = await response.json();
    dispatch({ type: "DELETE_CATEGORY", payload: data });
    return data;
  } catch (err) {
    console.error("Error delete category details:", err);
  }
};
